import clsx from 'clsx';
import * as React from 'react';

type Props = {
  classes?: string;
  bold?: boolean;
  small?: boolean;
  children: React.ReactNode;
};

const Subheading = React.forwardRef<HTMLHeadingElement, Props>(function Subheading(
  // eslint-disable-next-line react/prop-types
  { bold = false, small = false, classes = 'text-white-100', children },
  ref
) {
  const isChildrenString = typeof children === 'string';
  return (
    <h6
      ref={ref}
      className={clsx(bold ? 'font-bold' : 'font-normal', small ? 'body-lg' : 'title-lg', 'leading-normal', classes)}
      data-text={isChildrenString ? children : ''}
    >
      {children}
    </h6>
  );
});

export default Subheading;
